import axios from "axios";
import { isAuth } from "./auth";
import CryptoJS from 'crypto-js';

const user = isAuth()

// Cookies are sent automatically with withCredentials: true
// No need for Authorization header anymore
export const notif = (data) => {
    axios.post('api/notification', data, { withCredentials: true })
}
export const notif_read = (id, set) => {
    axios.put('api/notification/' + id, { read: set }, { withCredentials: true })
}
export const formatDate = (dateString) => {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', timeZone: 'Asia/Jakarta' };
    return new Date(dateString).toLocaleString("in-ID", options)
}


export const formatDate01 = (dateString) => {
    const date = dateString == null || dateString === '' ? new Date() : new Date(dateString);
    if (Number.isNaN(date.getTime())) {
        return formatDate01(new Date());
    }
    // Selalu format kalender Asia/Jakarta (hindari mismatch UTC server vs WIB)
    return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Jakarta',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(date);
}


export const formatTime = (dateString) => {
    return new Date(dateString).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: 'Asia/Jakarta',
    })
}

export const formatJamKerja = (jam) => {
    if (!jam || jam === 0) return '-';
    const hours = Math.floor(jam);
    const minutes = Math.round((jam - hours) * 60);
    if (minutes === 0) {
        return `${hours} jam`;
    }
    return `${hours} jam ${minutes} menit`;
}

export const formatNumber = (num) => {
    if (num === null || num === undefined) return '';
    const numValue = typeof num === 'string' ? parseFloat(num) : num;
    if (isNaN(numValue)) return '';
    // If it's a whole number, return without decimals
    if (numValue % 1 === 0) {
        return numValue.toString();
    }
    // Otherwise, return with decimals (max 2 decimal places)
    return parseFloat(numValue.toFixed(2)).toString();
}

export const formatDateOnly = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    return day.toString().padStart(2, '0');
}

export const formatDayName = (dateString) => {
    const date = new Date(dateString);
    const options = { weekday: 'long' };
    return date.toLocaleDateString('id-ID', options);
}
export const saveHistory = (surat_id, status_id, text) => {
    const catatan = {
        user: user?.username,
        text: text
    }
    const history = {
        surat_id: surat_id,
        status_id: status_id,
        catatan: JSON.stringify(catatan)
    }
    axios.post('api/history', history, {
        withCredentials: true
    })
}

export const encryptObject = (data) => {
    const secret = process.env.REACT_APP_SECRET_KEY;
    if (!secret) {
        throw new Error('REACT_APP_SECRET_KEY is not set');
    }
    return CryptoJS.AES.encrypt(JSON.stringify(data), secret).toString()
}

